<h1 class="sr-only" i18n="sr-only@@topNavbar.title">Kopfzeile</h1>
<nav class="navbar">
  <div class="navbar-logo">
    <div [class.large]="!auth.isLoggedIn" class="brand">
      <img alt="CléA Logo" i18n-alt="Alt text@@topNavbar.logo" src="assets/images/logo.svg">
    </div>
  </div>

  @if (!auth.isLoggedIn) {
    <button
      (click)="login()"
      class="link login login-button-header"
      type="button"
      >
      <span class="icon icon-user"></span>
      <ng-container i18n="@@header.btn.login">Bereits ein Konto?</ng-container>
    </button>
  }

  @if (auth.isLoggedIn) {
    <div class="navbar-main">
      <h2 class="sr-only" i18n="sr-only@@topNavbar.mainNavigation">Hauptnavigation</h2>
      <ul class="navbar-nav">
        <li class="nav-item">
          <div #rlas="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLinkActive]="['link-active']">
            <a [routerLink]="['/marketplace']" class="nav-link">
              <ng-container i18n="@@topNavbar.link.search">Suche</ng-container>
              @if (rlas.isActive) {
                <span class="sr-only" i18n="sr-only@@topNavbar.linkActiveState">(aktiv)</span>
              }
            </a>
          </div>
        </li>
        <li class="nav-item">
          <div #rlat="routerLinkActive"
            [class.has-badge]="employment.countOpenRequestsAndNewMessages"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLinkActive]="['link-active']">
            @if (auth.isRecipient) {
              <a [routerLink]="['/team']" class="nav-link">
                <ng-container i18n="@@topNavbar.link.myTeam">Mein Team</ng-container>
                @if (rlat.isActive) {
                  <span class="sr-only" i18n="sr-only@@topNavbar.linkActiveState">(aktiv)</span>
                }
              </a>
            }
            @if (auth.isGiver) {
              <a [routerLink]="['/jobs']" class="nav-link">
                <ng-container i18n="@@topNavbar.link.myJobs">Meine Jobs</ng-container>
                @if (rlat.isActive) {
                  <span class="sr-only" i18n="sr-only@@topNavbar.linkActiveState">(aktiv)</span>
                }
              </a>
            }
          </div>
          <app-badge [pulse]="true" [symbol]="employment.countOpenRequestsAndNewMessages" flavor="alert"
            i18n="@@badge.unansweredMessages">Unbeantwortete Nachrichten vorhanden
                    </app-badge>
        </li>
      </ul>
    </div>
    <div class="navbar-profile">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link"
            href="https://www.clea.app/faq-zur-clea-assistenzplattform/"
            i18n="@@topNavbar.link.help"
            i18n-href="@@www-clea-app-faq-zur-clea-assistenzplattform"
            target="_blank"
          >Hilfe</a>
        </li>
        <li
          class="nav-item">
          <button
            #profileMenuTrigger="cdkOverlayOrigin"
            (click)="isProfileMenuOpen = !isProfileMenuOpen"
            (keyup.Space)="isProfileMenuOpen = !isProfileMenuOpen"
            [attr.aria-expanded]="isProfileMenuOpen"
            aria-controls="profile-menu"
            aria-haspopup="true"
            cdkOverlayOrigin
            class="profile-button"
            i18n-title="Title text@@topNavbar.link.profileMenu"
            title="Profil Menü"
            type="button">
            <img [src]="auth.userProfile.picture" alt="Profil Menü"
              i18n-alt="Alt text@@topNavbar.link.profileMenu">
          </button>
          @if (auth.isLoggedIn) {
            <ng-template
              (backdropClick)="isProfileMenuOpen=false"
              (overlayKeydown)="overlayKeydown($event)"
              [cdkConnectedOverlayBackdropClass]="'profile-menu-backdrop'"
              [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayOpen]="isProfileMenuOpen"
              [cdkConnectedOverlayOrigin]="profileMenuTrigger"
              cdkConnectedOverlay>
              <ul #profileMenuList (keydown.ArrowDown)="arrowDownOnMenu($event)"
                (keydown.ArrowUp)="arrowUpOnMenu($event)" cdkTrapFocus cdkTrapFocusAutoCapture
                class="navbar-menu" id="profile-menu"
                role="menu">
                <li class="menuitem-info" role="none">
                  <span class="strong">{{ auth.userProfile.given_name }} {{ auth.userProfile.family_name }}</span><br>
                  <span>{{ auth.userProfile.email }}</span>
                </li>
                <li class="p-0">
                  <ion-item>
                    <ion-label [class]="isProfileActive ? 'checked' : 'unchecked'">
                      @if (isProfileActive) {
                        <ng-container i18n="@@topNavbar.btn.profileEnabled">
                                            Profil auffindbar
                                        </ng-container>
                      }
                      @if (!isProfileActive) {
                        <ng-container i18n="@@topNavbar.link.profileDisabled">
                                            Profil ist verborgen
                                        </ng-container>
                      }
                    </ion-label>
                    <ion-toggle (click)="updateIsProfileActive($event)" [checked]="isProfileActive"
                    mode="ios" name="isProfileActive" slot="end"></ion-toggle>
                  </ion-item>
                </li>
                <li>
                  <a (click)="isProfileMenuOpen=false" [routerLink]="['/marketplace', 'me']"
                    class="nav-link" i18n="@@topNavbar.link.viewMyProfile"
                    role="menuitem">
                                    Mein öffentliches Profil anzeigen
                                </a>
                </li>
                <li>
                  <a (click)="isProfileMenuOpen=false" [routerLink]="['/profile']" class="nav-link"
                    i18n="@@topNavbar.link.editMyProfile" role="menuitem">
                                    Profil bearbeiten
                                </a>
                </li>
                <li>
                  <button (click)="identity.logout(); isProfileMenuOpen=false;" class="link nav-link"
                    i18n="@@topNavbar.link.signOut" role="menuitem">Abmelden
                                </button>
                </li>
              </ul>
            </ng-template>
          }
        </li>
      </ul>
    </div>
  }
</nav>
